import { render, staticRenderFns } from "./GlobalConfirmationDialog.vue?vue&type=template&id=ed78ed10&scoped=true"
import script from "./GlobalConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./GlobalConfirmationDialog.vue?vue&type=script&lang=ts"
import style0 from "./GlobalConfirmationDialog.vue?vue&type=style&index=0&id=ed78ed10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed78ed10",
  null
  
)

export default component.exports